import "./Grammar.scss"

import { useEffect, useRef, useState } from "react"

import { shuffle } from "../../../helpers/utils"
import { config } from "../../../config"

import { Progress } from "../Progress"

import toast from "react-hot-toast"

// audios
import correct from "../../../assets/audio/correct.mp3"
import incorrect from "../../../assets/audio/incorrect.mp3"
import { randomWrongMsg } from "../../../helpers/msgs"
import { useTranslation, Trans } from "react-i18next"

var ok_audio = new Audio(correct)
var wrong_audio = new Audio(incorrect)
ok_audio.volume = 0.5
wrong_audio.volume = 0.5

const FillTheBlank = ({ exercise, difficulty, setAsDone, next }) => {
  const { t } = useTranslation()

  const n = exercise.options.length,
    ini = Array(n).fill(null),
    [selected, setSelected] = useState(ini),
    [verifying, setVerifying] = useState(false),
    [done, setDone] = useState(false)

  useEffect(() => {
    setSelected(Array(exercise.options.length).fill(null))
    setVerifying(false)
    setDone(false)
  }, [exercise])

  const fillNextBlank = (opt) => {
    if (done) return
    const i = selected.indexOf(null)
    if (i === -1) return
    setSelected((current) => {
      let newSelected = [...current]
      newSelected[i] = opt
      return newSelected
    })
  }

  const verify = () => {
    if (verifying || done) return

    setVerifying(true)

    setTimeout(() => {
      const all_ok = exercise.answers
        // aix ~ answer index; bix ~ blank index
        .map((aix, bix) => exercise.options[bix][aix] === selected[bix])
        .reduce((acc, next) => acc && next, true)

      setVerifying(false)
      setDone(all_ok)

      if (all_ok) setAsDone()
      else if (difficulty === "easy")
        // corrijo las erroneas
        setSelected((_) =>
          exercise.answers.map((aix, bix) =>
            exercise.options[bix][aix] === selected[bix] ? selected[bix] : null
          )
        )
    }, 1000)
  }

  // sentence
  const Sentence = () => {
    const parts = exercise.text.split(/(\$\d+)/)

    const Blank = ({ six }) => {
      // six ~ selected index
      const toggle = () => {
        if (done) return
        if (selected[six] !== null)
          setSelected((current) => {
            let newSelected = [...current]
            newSelected[six] = null
            return newSelected
          })
      }
      return (
        <>
          <span
            onClick={() => toggle()}
            className={
              "fill-blank " + (selected[six] !== null ? "btn blanco" : "")
            }>
            {selected[six] !== null ? selected[six] : <>&nbsp;</>}
          </span>
        </>
      )
    }

    return (
      <>
        <center id="sentence" className="my-5 py-3">
          {parts.map((s, ix) => {
            const m = /^\$(\d+)$/.exec(s)
            return m !== null ? (
              <Blank key={ix} six={parseInt(m[1] - 1)} />
            ) : (
              <span key={ix} className="fixed-text">
                {s}
              </span>
            )
          })}
        </center>
      </>
    )
  }

  const Option = ({ value }) => {
    if (selected.indexOf(value) !== -1) return null

    return (
      <>
        <button
          className="btn mx-2 mb-2 vacio"
          onClick={() => fillNextBlank(value)}>
          {value}
        </button>
      </>
    )
  }

  const OptionsEasy = () => {
    const current = selected.indexOf(null)
    return exercise.options.map((options, bix) => (
      <div
        key={bix}
        style={{ filter: current === -1 || current === bix ? "" : "blur(2px)" }}
        className="row mb-2">
        <center>
          {options.map((option, ix) => (
            <Option key={ix} value={option} />
          ))}
        </center>
      </div>
    ))
  }

  const OptionsHard = () => {
    return (
      <>
        <div className="row mb-2 justify-content-md-center">
          <div className="col-lg-6 col-12">
            <center>
              {shuffle(exercise.options.flat()).map((option, ix) => (
                <Option key={ix} value={option} />
              ))}
            </center>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <center>
        <h3 className="mb-0 mt-5">
          {t("games.language_practice.fill_the_phrase")}
        </h3>
      </center>

      <Sentence />

      {difficulty === "easy" && <OptionsEasy />}
      {difficulty === "hard" && <OptionsHard />}

      <ExerciseBottomButtons
        next={next}
        verifying={verifying}
        done={done}
        verify={verify}
      />
    </>
  )
}

const ExerciseBottomButtons = ({ next, verifying, done, verify }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="row justify-content-md-center mt-3">
        <div className="col-lg-4 col-6 mt-5">
          <button
            className="btn vacio w-100"
            onClick={() => next()}
            style={{ border: "none" }}>
            {t(`games.language_practice.skip_exercise`)}
          </button>
        </div>
        <div className="col-lg-4 col-6 mt-5">
          <button
            className={
              "btn w-100 " +
              (verifying ? "btn-secondary disabled" : done ? "verde" : "azul")
            }
            onClick={() => (done ? next() : verify())}>
            {done
              ? t(`games.language_practice.next`)
              : verifying
              ? t(`games.language_practice.checking`) + "..."
              : t(`games.language_practice.check`)}
          </button>
        </div>
      </div>
    </>
  )
}

const SelectImg = ({ exercise, difficulty, setAsDone, next }) => {
  const [selected, setSelected] = useState(null),
    [verifying, setVerifying] = useState(false),
    [done, setDone] = useState(false)

  useEffect(() => {
    setSelected(null)
    setVerifying(false)
    setDone(false)
  }, [exercise])

  const { t } = useTranslation()

  const title =
    difficulty === "easy" ? (
      <Trans
        i18nKey="games.language_practice.select_image_word"
        values={{ word: exercise.text }}
        components={[<u />]}
      />
    ) : (
      t(`games.language_practice.select_image_definition`) + ":"
    )

  const verify = () => {
    if (verifying || done) return
    setVerifying(true)
    setTimeout(() => {
      const ok = selected === exercise.answer
      if (ok) {
        ok_audio.currentTime = 0
        ok_audio.play()
      } else {
        wrong_audio.currentTime = 0
        wrong_audio.play()
        const m = randomWrongMsg()
        toast(m.text, {
          icon: m.emoji,
        })
      }
      setVerifying(false)
      // console.log(setDone)
      setDone(ok)
      if (ok) setAsDone()
      else setSelected(null)
    }, 1_000)
  }

  const Definition = () => {
    return (
      <>
        <div className="row">
          <center id="sentence" className="mt-5 mb-4 pt-3">
            "<i>{exercise.text}</i>"
          </center>
        </div>
      </>
    )
  }

  return (
    <>
      <center>
        <h3 className="mb-0 mt-5">{title}</h3>
      </center>

      {difficulty === "hard" && <Definition />}

      <div className="row justify-content-md-center">
        <div className="col-lg-8 col-12">
          <div
            id="select-img"
            className="d-flex justify-content-around align-items-center flex-row mt-4">
            {exercise.options.map((opt, ix) => {
              const url = `${config.imgUrl}/words/${opt}`
              return (
                <div
                  key={ix}
                  className={
                    "selectable w-100 " + (selected === opt ? "selected" : "")
                  }
                  onClick={() => setSelected(opt)}>
                  <center>
                    <img alt=":(" src={url} className="w-75" />
                  </center>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <ExerciseBottomButtons
        next={next}
        verifying={verifying}
        done={done}
        verify={verify}
      />
    </>
  )
}

const SelectInvImg = ({ exercise, difficulty, setAsDone, next }) => {
  const [selected, setSelected] = useState(null),
    [verifying, setVerifying] = useState(false),
    [done, setDone] = useState(false),
    form = useRef()

  useEffect(() => {
    form.current.reset()
    setSelected(null)
    setVerifying(false)
    setDone(false)
  }, [exercise])

  const verify = () => {
    if (verifying || done) return
    setVerifying(true)
    setTimeout(() => {
      const ok = exercise.answer === selected
      if (ok) {
        ok_audio.currentTime = 0
        ok_audio.play()
      } else {
        wrong_audio.currentTime = 0
        wrong_audio.play()
        const m = randomWrongMsg()
        toast(m.text, {
          icon: m.emoji,
        })
      }
      setVerifying(false)
      setDone(ok)
      if (ok) setAsDone()
      else setSelected(null)
    }, 1_000)
  }

  const url = `${config.imgUrl}/words/${exercise.img}`

  const { t } = useTranslation()

  return (
    <>
      <center>
        <h3 className="mb-0 mt-5">
          {t(`games.language_practice.select_definition_image`)}:
        </h3>
      </center>

      <div className="row justify-content-md-center">
        <center>
          <div className="col-lg-2 col-6 my-5">
            <img alt={exercise.img} src={url} className="w-75" />
          </div>
        </center>
      </div>

      <div className="row justify-content-md-center">
        <div className="col-lg-6 col-12">
          <form ref={form}>
            {exercise.options.map((opt, ix) => (
              <div key={ix} className="form-check form-check-inline">
                <input
                  onClick={() => setSelected(ix)}
                  className="form-check-input"
                  type="radio"
                  name="opt"
                />
                <p className="ps-3">{opt}</p>
              </div>
            ))}
          </form>
        </div>
      </div>

      <ExerciseBottomButtons
        next={next}
        verifying={verifying}
        done={done}
        verify={verify}
      />
    </>
  )
}

export const Grammar = ({
  data,
  setData,
  difficulty = "hard",
  winCallback,
  debugMode = false,
}) => {
  const n = data.length,
    [dones, setDones] = useState(Array(n).fill(false)),
    [dix, setDix] = useState(0), // dix ~ doing index
    [progress, setProgress] = useState(0)

  const next = () => {
    setDix((current) => {
      const ys = [...dones].map((x, ix) => [x, ix]),
        n = [...ys.slice(dix + (1 % dones.length)), ...ys.slice(0, dix)]
          .filter((x) => x[0] === false)
          .map((x) => x[1])
          .shift()

      return n === undefined ? current : n
    })
  }

  const setAsDone =
    (
      eix // eix ~ exercise index
    ) =>
    () => {
      setDones((current) => {
        let newsDones = [...current]
        newsDones[eix] = true
        const ds = newsDones.reduce((acc, next) => acc + (next ? 1 : 0), 0)
        setProgress(ds / n)

        if (ds === n) winCallback()

        return newsDones
      })
      next()
    }

  const is = (entry, test) => entry.type.toLowerCase() === test

  return (
    <>
      <div className="row justify-content-md-center">
        <div className={"col-lg-8 col-12 " + (debugMode ? "pt-4" : "")}>
          {!debugMode && <Progress ratio={progress} />}

          {is(data[dix], "fill") && (
            <FillTheBlank
              key={1}
              exercise={data[dix]}
              difficulty={difficulty}
              setAsDone={setAsDone(dix)}
              next={next}
            />
          )}

          {is(data[dix], "img") && (
            <SelectImg
              key={2}
              exercise={data[dix]}
              difficulty={difficulty}
              setAsDone={setAsDone(dix)}
              next={next}
            />
          )}

          {is(data[dix], "invimg") && (
            <SelectInvImg
              key={3}
              exercise={data[dix]}
              difficulty={difficulty}
              setAsDone={setAsDone(dix)}
              next={next}
            />
          )}
        </div>
      </div>
    </>
  )
}
